module.exports = __webpack_public_path__ + "static/img/1_1_1_2.894e2e5d.jpg";